import {apBasePath} from "./_base";

export default apBasePath.appendPathSegment<{}>("/create-acct");